import { ActionConsts } from '@Definitions/index';

export interface ITask {
  taskId: string;
  timestamp: string;
  provider: {
    id: string;
    name: string;
    image: string;
  };
  answers: {
    title: string;
    field_key: string;
    value: string;
  }[];
}

export const INITIAL_STATE = {
  patientInbox: [] as ITask[],
  isLoading: false,
};

export enum TaskTypeCode {
  BOOK_TO_DONE_COHORT = 'book_to_done_cohort',
  REPORT_READING = 'report_reading',
}

export const TaskReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case ActionConsts.Task.GetPatientInboxInit:
      return {
        ...state,
        isLoading: true,
      };
    case ActionConsts.Task.GetPatientInboxSuccess:
      return {
        ...state,
        patientInbox: action.payload,
        isLoading: false,
      };
    case ActionConsts.Task.GetPatientInboxFail:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default TaskReducer;
